import "./badge.scss";

interface BadgeProps {
  items: Array<{ text: string; color: string }>;
}

const Badge = ({ items }: BadgeProps) => {
  return (
    <div className="d-flex align-items-center gap-2">
      {items.map((item) => (
        <div
          key={item.text + item.color}
          className="badge-container"
          style={{ backgroundColor: item.color }}
        >
          {item.text}
        </div>
      ))}
    </div>
  );
};

export default Badge;
